import { MarketingBuyersWrapper } from "./marketing-buyers.style";
import { MarketingBuyersSection } from "./sections/marketing-buyers.section";

export const MarketingBuyersPage = ({ customerType = "registered" }) => <MarketingBuyersWrapper><MarketingBuyersSection customerType={customerType} /></MarketingBuyersWrapper>;
